import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "search-box position-relative" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "text-center text-success my-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, " Cargando...", -1)
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen p-2" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center" }
const _hoisted_14 = { class: "mb-0 text-paragraph" }
const _hoisted_15 = { class: "fw-bold" }
const _hoisted_16 = { class: "fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_spinner = _resolveComponent("b-spinner")!
  const _component_TableAuditColumns = _resolveComponent("TableAuditColumns")!
  const _component_b_table = _resolveComponent("b-table")!
  const _component_b_pagination = _resolveComponent("b-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", _hoisted_4, [
          _createVNode(_component_b_form_input, {
            modelValue: _ctx.table.filters.search,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.table.filters.search) = $event)),
            class: "form-control shadow-none",
            type: "search",
            placeholder: "Buscar..."
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_b_table, {
          id: "tableList",
          class: "table text-nowrap align-middle mb-0",
          striped: "",
          hover: "",
          "sticky-header": "",
          small: "",
          items: _ctx.filteredItems,
          fields: _ctx.table.headers,
          busy: _ctx.table.loading,
          "per-page": _ctx.table.rowsPerPage,
          "current-page": _ctx.table.currentPage
        }, {
          "table-busy": _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_b_spinner, { class: "align-middle" }),
              _hoisted_8
            ])
          ]),
          "cell(TeacherName)": _withCtx(({ item }) => [
            _createElementVNode("a", {
              onClick: ($event: any) => (_ctx.openForm(item.Id)),
              class: "cursor-pointer text-black fw-bold text-decoration-none"
            }, _toDisplayString(item.TeacherName), 9, _hoisted_9)
          ]),
          "cell(CreatedByFormat)": _withCtx(({ item }) => [
            _createVNode(_component_TableAuditColumns, {
              item: item,
              mode: "created"
            }, null, 8, ["item"])
          ]),
          "cell(ModifiedByFormat)": _withCtx(({ item }) => [
            _createVNode(_component_TableAuditColumns, {
              item: item,
              mode: "modified"
            }, null, 8, ["item"])
          ]),
          "cell(action)": _withCtx(({ item }) => [
            _createElementVNode("button", {
              type: "button",
              onClick: ($event: any) => (_ctx.openForm(item.Id)),
              class: "bg-transparent p-0 border-0 text-paragraph"
            }, _hoisted_12, 8, _hoisted_10)
          ]),
          _: 1
        }, 8, ["items", "fields", "busy", "per-page", "current-page"]),
        _createVNode(_component_b_pagination, {
          modelValue: _ctx.table.currentPage,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.table.currentPage) = $event)),
          "total-rows": _ctx.rows,
          "per-page": _ctx.table.rowsPerPage,
          "aria-controls": "tableList",
          class: "mt-3"
        }, null, 8, ["modelValue", "total-rows", "per-page"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("p", _hoisted_14, [
          _createTextVNode(" Mostrando "),
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.table.rowsPerPage), 1),
          _createTextVNode(" de "),
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.table.records.length), 1),
          _createTextVNode(" resultados ")
        ])
      ])
    ])
  ]))
}